import { useState } from "react";
import ClassesBox from "../components/ClassesBox/ClassesBox";
import Footer from "../components/Footer/Footer";
import CyclingIcon from "../images/features/gym-bike.png";

function Classes() {
  const [load, setLoad] = useState(true);

  const loadMore = () => {
    setLoad(!load);
  };

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section className="login-section text-center ">
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            Sessions
          </h1>
        </div>

        {/* boxes 1*/}
        <div
          className={`container gap-12 page-padding py-[10rem] md1000:grid-cols-2 min620:grid-cols-1  grid-cols-3 grid-rows-3 text-left ${
            load ? "grid" : "hidden"
          }`}
        >
          <ClassesBox
            bgImg="cycling-bg"
            title="Cycling"
            icon={CyclingIcon}
          />
          <ClassesBox
            bgImg="mma-bg"
            title="Boxing"
          />
          <ClassesBox
            bgImg="karate-bg"
            title="Kick boxing"
          />
          <ClassesBox
            bgImg="powerlift-bg"
            title="Power Lifting"
          />
          <ClassesBox
            bgImg="workout-bg"
            title="Workout"
          />
          <ClassesBox
            bgImg="crossfit-bg"
            title="Crossfit"
          />
          <ClassesBox
            bgImg="treadmill-bg"
            title="Running"
          />
        </div>

        {/* boxes 2*/}
        <div
          className={`container gap-12 page-padding py-[10rem] grid-cols-3 md1000:grid-cols-2 min620:grid-cols-1  grid-rows-3 text-left  ${
            load ? "hidden" : "grid"
          }`}
        >
          <ClassesBox
            bgImg="cycling-bg"
            title="Cycling"
            icon={CyclingIcon}
          />
          <ClassesBox
            bgImg="mma-bg"
            title="Boxing"
          />
          <ClassesBox
            bgImg="karate-bg"
            title="Kick boxing"
          />
          <ClassesBox
            bgImg="powerlift-bg"
            title="Power Lifting"
          />
          <ClassesBox
            bgImg="workout-bg"
            title="Workout"
          />
          <ClassesBox
            bgImg="crossfit-bg"
            title="Crossfit"
          />
          <ClassesBox
            bgImg="treadmill-bg"
            title="Running"
          />
          <ClassesBox
            bgImg="bodybuilding-bg"
            title="Body Building"
          />
          <ClassesBox
            bgImg="box-bg"
            title="Mma"
          />
          <ClassesBox
            bgImg="yoga-bg"
            title="Yoga"
          />
          <ClassesBox
            bgImg="fitness-bg"
            title="Fitness"
          />
        </div>

        <button
          className="text-[1.5rem] text-white bg-slate-600 px-14 py-6 font-medium uppercase shadow-2xl mb-14"
          onClick={() => {
            loadMore();
            goTop();
          }}
        >
          {load ? "show more" : "show less"}
        </button>

        <Footer />
      </section>
    </>
  );
}

export default Classes;
